// AHA-46648 — sidebar "Shared with Me" points at the workspace app's merged
// shared listing (/shared inside the aha-workspace embed: shared folders +
// shared decks + ahafiles shared files, surveys included) instead of the
// legacy presentations-only /apps/shared-presentations. Staging-first
// rollout: flip the flag in Unleash, no deploy.
export const WORKSPACE_SHARED_FLAG = 'AHA-46648-workspace-shared-sidebar'

// Gate on the variant name, never on enabled/disabled: a boolean check cannot
// distinguish "control" from "the flag failed to load", and treating the latter
// as control corrupts the Mixpanel exposure split. Only an explicit TREATMENT
// retargets the entry; every other value (including a missing flag, which
// getVariant reports as `disabled`) keeps the legacy shared-presentations page.
export const WORKSPACE_SHARED_VARIANTS = {
  TREATMENT: 'treatment',
  CONTROL: 'control',
}
